import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable } from "rxjs";
import {
	type CreateImageInput,
	type Image,
	type UpdateImageInput,
} from "src/app/schema";
import { ApiService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class ImageService {
	private readonly _httpClient = inject(HttpClient);
	private readonly _api = inject(ApiService);

	public createImage(image: CreateImageInput): Observable<Image> {
		return this._httpClient.post<Image>(
			`${this._api.inventoryApiEndpoint}/image`,
			image,
		);
	}

	public updateImage(image: UpdateImageInput): Observable<Image> {
		return this._httpClient.put<Image>(
			`${this._api.inventoryApiEndpoint}/image`,
			image,
		);
	}

	public deleteImage(imageId: string): Observable<{ id: string }> {
		return this._httpClient.delete<{ id: string }>(
			`${this._api.inventoryApiEndpoint}/image/${imageId}`,
		);
	}
}
